import { Table } from "@/features/Table";
import { type G4Position, g4_positions_columns } from "./columns";
import { type FilterG4PositionsSchema, FilterG4Positions } from "./filter";

const client = "g4";
const table_name = "g4_positions";

export const G4PositionsTable = () => {
  return (
    <Table<G4Position, FilterG4PositionsSchema>
      label="Positions"
      client={client}
      table_name={table_name}
      columns={g4_positions_columns}
      filter={<FilterG4Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
